export default {
  'booking.issueDate': 'تاریخ صدور',
  'booking.exporter': 'صادر کننده',
  'booking.email': 'ایمیل',

  'booking.PassengerNameInEnglish': 'نام مسافر به انگلیسی',
  'booking.PassengerLastNameInEnglish': 'نام خانوادگی به انگلیسی',
  'booking.NationalityOfThePassenger': 'ملیت مسافر',
  'booking.genderOfThePassenger': 'جنسیت مسافر ',
  'booking.LoginToAccount': 'ورود به حساب کاربری',
  'booking.userGoForCreateAccount':
    'اگر حسابی ندارید، همین حالا یک حساب کاربری ایجاد کنید و از مزایای فراوان باشگاه مشتریان تریپسی استفاده کنید.',
  'booking.continuWithGuestUser':
    'در صورتیکه به عنوان کاربر مهمان ادامه دهید، از امتیاز باشگاه مشتریان بی بهره خواهید بود.',
  'booking.totalsales': 'مجموع فروش توسط کانتر',
  'booking.FirstPassenger': 'مسافر اول',
  'booking.totalpriceofpassengers': 'مجموع هزینه مسافران',
  'booking.ticketPriceDetails': 'جزئیات قیمت بلیط',
  'booking.toViewTheListOfPreviousPassengers': 'برای مشاهده لیست مسافران قبلی',
  'booking.pleaselogin': 'فرمایید ...',
  'booking.pricedetails': 'جزئیات قیمت',
  'booking.travelerdetails': 'جزئیات مسافران',
  'booking.buy_ticket': 'خرید بلیط',
  'booking.wheretogo': 'دوست دارید به کجا سفر کنید ؟',
  'booking.searchflight': 'جستجوی پرواز',
  'booking.selectflight': 'انتخاب پرواز',
  'booking.oneway': 'یکطرفه',
  'booking.onewaytrip': 'یکطرفه',
  'booking.roundtrip': 'رفت و برگشت',
  'booking.multicity': 'چند مسیره',
  'booking.bestguarantee': 'بهترین گارانتی',
  'booking.getdeals': 'پیشنهادات ویژه',
  'booking.signupnow': 'هم اکنون ثبت نام کنید',
  'booking.from': 'مبدا',
  'booking.to': 'مقصد',
  'booking.guest': 'مسافر',
  'booking.city': 'شهر',
  'booking.country': 'کشور',
  //because using key of drop down use the exact key
  'booking.Adult': 'بزرگسال',
  'booking.adult': 'بزرگسال',
  'booking.child': 'خردسال',
  'booking.Child(Age 2-12)': 'خردسال  (2 تا 12 سال)',
  'booking.Infant(Age 0-2)': 'نوزاد  (0 تا 2 سال)',
  'booking.senior(Over 65)': 'سنیور سیتیزن  (بالای 65 سال) ',
  'booking.senior': 'سنیور سیتیزن',
  'booking.students(Over 18)': 'دانشجو(بالای 18 سال)',
  'booking.students': 'دانشجو',
  'booking.toddler(Age 0-2)': 'نوزاد با صندلی  (زیر 2 سال) ',
  'booking.toddler': 'نوزاد با صندلی',
  'booking.guestsandcities': 'شهرها و مسافران',
  'booking.startover': 'شروع مجدد',
  'booking.showmoredate': 'نمایش تاریخ های بیشتر',
  'booking.selectdate': ' انتخاب تاریخ',
  'booking.date': 'تاریخ پرواز',
  'booking.changedate': 'تغییر تاریخ پرواز',
  'booking.airline': 'خطوط هوایی',
  'booking.departs': 'ساعت خروج',
  'booking.arrives': 'ساعت ورود',
  'booking.duration': 'مدت پرواز',
  'booking.travelclass': 'کلاس',
  'booking.priceperadult': 'بزرگسال',
  'booking.priceperchild': 'خردسال',
  'booking.priceperinfant': 'نوزاد',
  'booking.flightnumber': 'شماره پرواز',
  'booking.remainseat': 'صندلی باقیمانده',
  'booking.cost': 'مبلغ',
  'booking.showmore': 'مشاهده بیشتر',
  'booking.passportno': 'شماره گذرنامه',
  'booking.birthcountry': 'محل تولد',
  'booking.passportcountry': 'ملیت',
  'booking.passportexpireyear': 'سال انقضا گذرنامه',
  'booking.passportexpiremonth': 'ماه انقضا گذرنامه',
  'booking.passportexpireday': 'روز انقضا گذرنامه',
  'booking.birthyear': 'سال تولد',
  'booking.birthmonth': 'ماه تولد',
  'booking.birthday': 'تاریخ تولد',
  'booking.completeform': 'ذخیره اطلاعات و ادامه',
  'booking.changeavatar': 'تغییر آواتار',
  'booking.passengerinfo': 'اسامی مسافران',
  'booking.isiranian': 'ملیت ایرانی',
  'booking.othernationality': 'سایر ملیت ها',
  'booking.perviousepassenger': 'انتخاب از لیست مسافران',
  'booking.index': 'ردیف',
  'booking.primarytraveler': 'مسافر اصلی',
  'booking.adultinformation': 'اطلاعات بزرگسال',
  'booking.childinformation': 'اطلاعات خردسال',
  'booking.infantinformation': 'اطلاعات نوزاد',
  'booking.phone': 'شماره تلفن',
  'booking.totalprice': 'قیمت کل',
  'booking.stopcount': 'توقف',
  'booking.airplanetype': 'نوع هواپیما',
  'booking.international': 'پرواز خارجی',
  'booking.domestic': 'پرواز داخلی',
  'booking.notexist': 'نا موجود',
  'booking.noavailableflight':
    'پروازی  در تاریخ مورد نظر یافت نگردید،لطفا تاریخ دیگری را جستجو فرمایید',
  'booking.departurecities': 'شهر مبدا',
  'booking.returncities': 'شهر مقصد',
  'booking.departuredate': 'تاریخ خروج',
  'booking.returndate': 'تاریخ ورود ',
  'booking.departuretime': 'ساعت خروج',
  'booking.returntime': 'ساعت ورود',
  'booking.paynow': 'پرداخت نهایی',
  'booking.sigin': 'ورود',
  'booking.signup': 'ثبت نام',
  'booking.notregister': 'تا کنون ثبت نام نکرده اید',
  'booking.elevatemembers': 'قبلا عضو بوده اید',
  'booking.departureflightinfo': 'اطلاعات رفت',
  'booking.returnflightinfo': 'اطلاعات برگشت',
  'booking.previouspassenger': 'لیست مسافران قبلی',
  'booking.hi': 'سلام ، ',
  'booking.travelwith': 'همراهان شما در سفر',
  'booking.ticket': 'بلیط شما در حال صادر شدن است',
  'booking.successpayment': 'پرداخت شما با موفقیت انجام گرفت',
  'booking.previousepassengerlist': 'لیست مسافران قبلی',
  'booking.bookingflights': 'لیست سفارشات شما ',
  'booking.flightno': 'شماره پرواز',
  'booking.infant': 'نوزاد',
  'booking.male': 'مرد',
  'booking.female': 'زن',
  'booking.departureflight': 'پرواز رفت',
  'booking.returnflight': 'پرواز برگشت',
  'booking.importantTips': 'نکات مهم و ضروری',
  'booking.passengerArrivringTip':
    'مسافر میبایست 4 ساعت قبل از پرواز در فرودگاه حضور  بهم رساند تا مراحل سوار شدن را در موعد مقرر انجام دهد',
  'booking.payTextTip':
    ' عوارض خروج از کشور را به صورت انلاین  از درگاه سداد بانک ملی پرداخت نمایید تا از معطلی در فرودگاه جلوگیری نمایید',

  'booking.showticket': 'نمایش بلیط',
  'booking.cancel': 'استرداد',
  'booking.passengers': 'مسافران',
  'booking.returnprice': 'مبلغ قابل استرداد',
  'booking.cancelstatus': 'وضعیت استرداد',
  'booking.cancelreason': 'چرا می خواهید بلیط خود را لغو کنید ؟',
  'booking.personalproblem':
    'دلایل شخصی-استرداد بر اساس قوانین شرکتهای هواپیمایی',
  'booking.airlineproblem': 'لغو پرواز توسط ایرلاین',
  'booking.flightproblem': 'تاخیر یا تعجیل پرواز بیش از دو ساعت',
  'booking.back': 'بازگشت',
  'booking.nextstep': 'مرحله بعد',
  'booking.cancelingrules': 'قوانین استرداد پرواز',
  'booking.wait': 'لطفا شکیبا باشید ...',
  'booking.flights': 'پرواز',
  'booking.cancelpayment': 'تراکنش شما با خطا مواجه گردید',
  'booking.refid': 'کد پیگیری شما: ',
  'booking.airport': 'فرودگاه',
  'booking.flighttime': 'زمان پرواز',
  'booking.flightstopcount': 'تعداد توقف',
  'booking.morning': 'صبح ( ساعت 0 تا 8)',
  'booking.noon': 'ظهر ( ساعت 8 تا 14)',
  'booking.afternoon': 'عصر( ساعت 14 تا 20)',
  'booking.night': 'شب ( ساعت 20 به بعد)',
  'booking.sort': 'مرتب سازی',
  'booking.sortbyprice': 'براساس قیمت',
  'booking.sortbytime': 'براساس ساعت',
  'booking.nonstop': 'بدون توقف',
  'booking.onestop': 'یک توقف',
  'booking.morethanonestop': 'بیش از یک توقف',
  'booking.origin': 'مبدا',
  'booking.destination': 'مقصد',
  'booking.startdate': 'تاریخ شروع',
  'booking.enddate': 'تاریخ پایان',
  'booking.search': 'جستجو',
  'booking.filter': 'فیلترها',
  'booking.agree': 'را قبول دارم',
  'booking.cancelrules': 'قوانین استرداد',
  'booking.flightscount': ' پرواز یافت شد!',
  'booking.clearfilter': 'بازنشانی',
  'booking.gifavatar': 'انتخاب آواتار متحرک',
  'booking.avatar': 'انتخاب آواتار ',
  'booking.notfound': 'شهری یافت نگردید',
  'booking.nextyear': 'سال بعد',
  'booking.previousyear': 'سال قبل',
  'booking.details': 'جزییات',
  'booking.adultprice': 'قیمت هر بزرگسال',
  'booking.sortby': 'مرتب سازی',
  'booking.bydescendingpoint': 'امتیاز کاربر زیاد به کم',
  'booking.byascendingpoint': 'امتیاز کاربر کم به زیاد',
  'booking.bydescendingprice': 'قیمت پرواز زیاد به کم',
  'booking.byascendingprice': 'قیمت پرواز کم به زیاد',
  'booking.bydescendingtime': 'ساعت پرواز زیاد به کم',
  'booking.byascendingtime': 'ساعت پرواز کم به زیاد',
  'booking.justthis': 'فقط',
  'booking.searchpassenger': 'جستجو مسافر... ',
  'booking.edit': 'ویرایش',
  'booking.select': 'انتخاب',
  'booking.gotoday': 'برو به امروز',
  'booking.pricedetail': 'جزییات قیمت بلیط',
  'booking.passengertype': 'نوع',
  'booking.fareprice': 'قیمت پایه',
  'booking.tax': 'مالیات',
  'booking.moneyunit': '(تمام قیمت ها به تومان می باشد)',
  'booking.allairport': ' ( تمام فرودگاه ها ) ',
  'booking.noseatresult': 'تکمیل ظرفیت',
  'booking.sumprice': 'قیمت کل',
  'booking.terminal': 'ترمینال',
  'booking.byascendingduration': 'مدت پرواز کم به زیاد',
  'booking.today': 'امروز',
  'booking.bydescendingduration': 'مدت پرواز زیاد به کم',
  'booking.sameairport': 'ترمینال مبدا و مقصد نمی تواند یکسان باشد',
  'booking.stopin': ' توقف در',
  'booking.megaleapyearsale': 'جهش مگا، فروش سال',
  'booking.planasunnyd1': 'اکنون برای بیداری آفتاب برنامه ریزی کنید و با',
  'booking.planasunnyd2':
    'کرایه فوق العاده 20% تخفیف در هزنیه هایتان صرفه جویی کنید ',
  'booking.restrictionsapply': 'محدودیت های اعمال شده',
  'booking.grabaseat': 'یک صندلی بگیر',
  'booking.enjoywithbestfriends': 'با بهترین دوستانتان لذت ببرید',
  'booking.helpafriendd1': 'با بهترین دوستانتان برنامه ریزی کنید',
  'booking.helpafriendd2': ' و امتیاز خود را بالا ببرید',
  'booking.termsandconditionsapply': 'شرایط و ضوابط اعمال شده',
  'booking.bookhotels': 'رزرو هتل',
  'booking.booktours': 'رزرو تور',
  'booking.takeofffaster': 'سریع تر انجامش بده',
  'booking.earn10kpointsd1': ' با کارت ویزیت توریستی ',
  'booking.earn10kpointsd2': '  ده هزار امتیاز بدست بیاوردید ',
  'booking.learnmore': 'بیشتر بدانید',
  'booking.swipeforthesky': 'پرواز در آسمان',
  'booking.weathertoday': 'آب و هوای امروز',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    'برای کسب تجربه بیشتر و باارزش بروی زمین و آسمان ،با کارت ویزیت توریستی برنامه ریزی کنید ',
  'booking.firstoneonfirstoneoff': 'اولین بار روشن،اولین بار خاموش',
  'booking.inahurry':
    'با عجله ؟ صندلی در کابین اصلی یا صندلی در جلوی هواپیما را ترجیح می دهید.اولویتتان امنیت یا هزنیه کمتر.',
  'booking.feeltheupgrade': 'احساس ارتقا',
  'booking.travelinstylewithextralegroom':
    'کیفیت سفر خود را با زیرپایی های اضافی صندلی ،ایمنی سفر و مهم تر از همه انتخاب کابین اصلی ،بالا ببرید',
  'booking.takethefasttrack': 'مسیر را سریع پیگیری کن',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'احساس امنیت کامل همانند اینکه شما در مکان خود قرار داریدو پی بردن به اینکه چگونه از این مزایا لذت ببرید',
  'booking.corporaterewards': 'جوایز شرکت ها ',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'برای پرواز بهتر لازم نیست عجله داشته باشیم،برنامه پاداش شرکت ما که به کسب وکار های شما داده می شود چیز هایی است که شما در سفر هزنیه میکنید',
  'booking.packyourpoints': 'امتیازهای خود را دسته بندی کنید',
  'booking.livelargeat35,000feet':
    'پیوستن به افزایش و شروع رکورد کردن امتیازها، مزایا و پاداش پروازها ،تاریخ انقضا ندارد.',
  'booking.price': 'قیمت',
  'booking.baggages': 'بار مجاز',
  'booking.byascendingarrivetime': 'ساعت رسیدن کم به زیاد',
  'booking.allpassengerprice': 'قیمت بلیط تمامی مسافران',
  'booking.bydescendingarrivetime': 'ساعت رسیدن زیاد به کم',
  'booking.orderdate': 'تاریخ سفارش',
  'booking.traveldate': 'تاریخ سفر',
  'booking.passengername': 'نام مسافر',
  'booking.cancelticket': 'استرداد بلیط',
  'booking.operatedairline': 'ایرلاین اجرا کننده',
  'booking.count': 'تعداد',
  'booking.departureflighttime': 'ساعت پرواز رفت',
  'booking.returnflighttime': 'ساعت پرواز برگشت',
  'booking.returnstopcount': 'تعداد توقف برگشت',
  'booking.pc': 'بسته',
  'booking.kg': 'کیلوگرم',
  'booking.cabin': 'کلاس پرواز',
  'booking.layoverairports': 'فرودگاه ترانزیت',
  'booking.includeairports': 'شامل فرودگاه های',
  'booking.departduration': 'مدت پرواز رفت',
  'booking.returnduration': 'مدت پرواز برگشت',
  'booking.nightcount': 'شب',
  'booking.nights': 'شب',
  'booking.showflightdetail': 'جزییات پرواز',
  // "booking.toman": " دلار",
  'booking.toman': 'تومان',
  'booking.totalamount': 'مبلغ کل خرید',
  'booking.saletotalamount': 'مبلغ کل فروش',
  'booking.free': 'رایگان',
  'booking.hour': 'ساعت',
  'booking.minutes': 'دقیقه',
  'booking.and': 'و',
  'booking.nobaggage': 'بدون بار',
  'booking.mainterminal': 'ترمینال اصلی',
  'booking.shamsiShamsi': 'شمسی',
  'booking.shamsi': 'جلالی',
  'booking.miladi': 'میلادی',
  'booking.adultageerror': 'سن بزرگسال باید بالای 12 سال باشد',
  'booking.childageerror': 'سن خردسال  باید بالای 2 و زیر 12 سال باشد',
  'booking.infantageerror': 'سن نوزاد باید زیر 2 سال باشد',
  'booking.seniorageerror': 'سن سنیور سیتیزن باید بالای 65 سال باشد',
  'booking.toddlerageerror': 'سن نوزاد با صندلی باید زیر 2 سال باشد',
  'booking.passenger': 'مسافر',
  'booking.important': 'توجه !',
  'booking.identifynote':
    'نام و نام خانوادگی مسافران می بایست به انگلیسی و مطابق با گذرنامه وارد گردد.',
  'booking.validpassportdate':
    'تاریخ انقضای گذرنامه نسبت به تاریخ پرواز باید حداقل 6 ماه باشد',
  'booking.adt': 'بزرگسال',
  'booking.chd': 'خردسال',
  'booking.inf': 'نوزاد',
  'booking.passcount': 'تعداد مسافر',
  'booking.departure': 'رفت',
  'booking.return': 'برگشت',
  'booking.allflightinformation': 'تمام اطلاعات پرواز',
  'booking.notavailable': '--',
  'booking.previousemonth': 'ماه قبل',
  'booking.nextmonth': 'ماه بعد',
  'booking.passportexpiredate': 'تاریخ انقضا گذرنامه',
  'booking.arrivein': 'رسیدن در',
  'booking.nextdays': 'روز بعد',
  'booking.clearallfilter': 'حذف تمامی فیلترها',
  'booking.duplicatepassenger':
    'کد ملی یا شماره پاسپورت مسافر مورد نظر تکراری می باشد',
  'booking.policy': 'را مطالعه و تایید می نمایم',
  'booking.changecontact': 'اطلاعات بلیط به شخص زیر ارسال می گردد:  ',
  'booking.customeragreement': 'توافق نامه مشتری',
  'booking.flightrules': 'قوانین پرواز',
  'booking.changecontacttitle': 'تغییر اطلاعات گیرنده',
  'booking.fullname': 'نام و نام خانوادگی',
  'booking.address': 'آدرس',
  'booking.change': 'تغییر اطلاعات',
  'booking.firstname': 'نام',
  'booking.lastname': 'نام خانوادگی',
  'booking.departureairport': 'فرودگاه رفت',
  'booking.arrivalairport': 'فرودگاه مقصد',
  'booking.previousedays': 'روز قبل',
  'booking.day': 'روز',
  'booking.month': 'ماه',
  'booking.year': 'سال',
  'booking.changepassenger': 'تغییر تعداد مسافرین',
  'booking.editdepartcity': 'ویرایش شهر مبدا',
  'booking.editdestinationcity': 'ویرایش شهر مقصد',
  'booking.editdepartdate': 'ویرایش تاریخ رفت',
  'booking.editdestinationdate': 'ویرایش تاریخ برگشت',
  'booking.changepassengernotify':
    'در صورت تغییر تعداد مسافرین جستجوی مجدد انجام خواهد شد',
  'booking.edittooltip': 'جهت تغییر اطلاعات پرواز روی بخش مورد نظر کلیک نمایید',
  'booking.addflight': 'اضافه کردن پرواز',
  'booking.showmulticity': 'مشاهده تمامی پروازها',
  'booking.view': 'مشاهده',
  'booking.takeofffrom': ' ساعت پرواز از',
  'booking.at': 'ساعت',
  'booking.tripsi': 'تریپسی',
  'booking.includetax':
    'قیمت ها با احتساب مالیات و هزینه های خطوط هوایی می باشد',
  'booking.paymentsummery': 'جزییات صورتحساب',
  'booking.canceleditting': 'انصراف',
  'booking.books': 'رزرو شده',
  'booking.reserves': 'رزرو شده',
  'booking.showreserve': 'نمایش رزرو',
  'booking.of': 'از',
  'booking.canceled': 'کنسل',
  'booking.history': 'تاریخچه',
  'booking.searchpassengerinfo':
    'نام و نام خانوادگی ,کد ملی ,شماره پاسپورت و شماره سفارش و شماره بلیط و PNR',
  'booking.issued': 'خریداری شده',
  'booking.bought': 'خرید شده',
  'booking.serviceType': 'نوع خدمات',
  'booking.serviceName': 'هواپیما،قطار،هتل ...',
  'booking.invoicenumber': 'شماره سفارش',
  'booking.chooseticket': 'کدام بلیط را میخواهید کنسل کنید؟',
  'booking.cancelreturn': 'کنسل کردن پرواز برگشت',
  'booking.cancelroundtrip': 'کنسل کردن پرواز رفت و برگشت',
  'booking.nationalcode': 'کد ملی',
  'booking.counter': 'کانتر',
  'booking.sum': 'مجموع',
  'booking.transaction': 'گزارش ریزتراکنش',
  'booking.countercommission': 'گزارش سهم کانتر',
  'booking.domesticflightscount': 'تعداد پروازهای داخلی',
  'booking.internationalflightscount': 'تعداد پروازهای خارجی',
  'booking.flightCount': 'تعداد پرواز ها',
  'booking.createdate': 'تاریخ ثبت',
  'booking.income': 'درآمد',
  'booking.notwithdrawincome': 'درآمد برداشت نشده',
  'booking.notwithdrawpoint': 'امتیاز باقیمانده',
  'booking.withdrableincome': 'درآمد قابل برداشت',
  'booking.withdrablepoint': 'امتیاز قابل برداشت',
  'booking.pendingincome': 'درآمد معلق',
  'booking.pendingpoint': 'امتیاز معلق',
  'booking.collectedpoint': 'امتیاز کسب شده',
  'booking.spentpoint': 'امتیاز خرج شده',
  'booking.paymentstatus': 'وضعیت پرداخت',
  'booking.withdrawdate': 'تاریخ پرداخت',
  'booking.countername': 'نام و نام خانوادگی کانتر',
  'booking.previousweek': 'هفته قبل',
  'booking.nextweek': 'هفته بعد',
  // "booking.allprice": "تمامی قیمت ها به دلار می باشد",
  'booking.allprice': 'تمامی قیمت ها به تومان می باشد',
  'booking.allpriceisrial': 'تمامی قیمت ها به ریال می باشد',
  'booking.showallcalendar': 'مشاهده ماتریس قیمت',
  'booking.hideallcalendar': 'عدم نمایش ماتریس قیمت',
  'booking.multicitytrip': 'چند مسیره',
  'booking.selectstakeholder': 'انتخاب ذینفع ',
  'booking.changestakeholder': 'تغییر ذینفع ',
  'booking.ticketwithoutprice': 'بلیط بدون قیمت',
  'booking.markupticket': 'بلیط با Markup',
  'booking.orginalticket': 'بلیط اصلی',
  'booking.markup': 'مارک آپ',
  'booking.removeflight': 'حذف پرواز',
  'booking.continueguest': 'ادامه به عنوان مهمان',
  'booking.hotel': 'هتل',
  'booking.trackorder': 'پیگیری خرید',
  'booking.trackingcode': 'کد رهگیری',
  'booking.searchyourorders': 'رهگیری سفارشات',
  'booking.panel': 'پنل',
  'booking.baggagerules': 'قوانین بار',
  'booking.userpoint': 'امتیاز کاربر',
  'booking.notresult': 'کد رهگیری معتبر نیست',
  'booking.attachpassport': 'خواندن از پاسپورت',
  'booking.payhint': 'لطفا جهت ادامه ابتدا قوانین پرواز را تایید نمایید',
  'booking.completecontacttitle': 'تکمیل فرم',
  'booking.completecontactdescription':
    'لطفا اطلاعات شخص دریافت کننده بلیط را وارد نمایید',
  'booking.updatepassenger': 'بروزرسانی اطلاعات مسافر',
  'booking.paylater': 'بعدا پرداخت میکنم',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'مبلغ جریمه',
  'booking.sumcancelprice': 'مجموع مبلغ قابل استرداد',
  'booking.paymenttype': 'نحوه پرداخت',
  'booking.chargecredit': 'شارژ اعتبار تریپسی',
  'booking.chargecreditinfo':
    'مبلغ موردنظر حداکثر تا 7 روز کاری دیگر به اعتبار شما در تریپسی واریز خواهد شد.',
  'booking.deposit': 'واریز به حساب بانکی',
  'booking.depositinfo':
    'مبلغ موردنظر حداکثر تا 7 روز کاری دیگر به حساب بانکی که خرید از آن انجام شده، واریز خواهد شد',
  'booking.previousstep': 'مرحله قبل',
  'booking.cancelmessage':
    'درخواست کنسل شما با موفقیت ثبت گردید و در حال بررسی می باشد',
  'booking.chargecreditmessage':
    'مبلغ مورد نظر طبق قوانین تا ۷ روز کاری دیگر در حساب شما شارژ خواهد شد.',
  'booking.contactus': 'در صورت وجود مشکل با بخش پشتیبانی تریپسی تماس بگیرید',
  'booking.sendproblem': 'سایر درخواستها',
  'booking.notrefundable': 'غیر قابل استرداد',
  'booking.sendrequest': 'ارسال درخواست',
  'booking.withdrawtype': 'نوع درخواست',
  'booking.downloadticket': 'دانلود بلیط',
  'booking.hours': 'ساعت ',
  'booking.before': 'قبل',
  'booking.flight': 'پرواز',
  'booking.exacttime': 'ظهر',
  'booking.until': 'تا',
  'booking.afterflight': 'بعد از  پرواز',
  'booking.beforeflight': 'قبل از  پرواز',
  'booking.after': 'به بعد',
  'booking.fromhours': 'از',
  'booking.toprice': 'تا',
  'booking.agenycommission': 'کمیسیون آژانس',
  'booking.unknown': 'نامشخص',
  'booking.callsupport':
    'خطا در صدور بلیط لطفاً با بخش پشتیبانی تماس حاصل فرمایید',
  'booking.searchtimeout': 'جستجوی مجدد این پرواز ؟ ',
  'booking.timeout': 'زمان جستجو ...',
  'booking.searchagaininfo': 'مدت زمان جستجو برای این پرواز',
  'booking.searchagaininfomsg': 'به پایان رسیده است',
  'booking.searchagian': 'بلی',
  'booking.startagain': 'خیر',
  'booking.nocancelrules': 'قوانین پرواز یافت نگردید',
  'booking.andhigher': 'و بالاتر',
  'booking.printticket': 'چاپ بلیط',
  'booking.retrivedocument': 'در حال نمایش اطلاعات',
  'booking.forthepassenger': 'اطلاعات مسافر',
  'booking.flightticket': 'بلیط پرواز',
  'booking.ticketno': 'شماره بلیط',
  'booking.deptime': 'ساعت پرواز',
  'booking.cancelterm':
    '1- شرایط کنسل کردن پروازهای چارتر به قوانین ارائه دهنده بستگی دارد. این بدان معنی است که ممکن است هرگز لغو نشود.',
  'booking.attention':
    ' توجه: مسافران موظفند 2 ساعت قبل از پرواز در فرودگاه حضور یابند.',
  'booking.cancelrulehint':
    '2- هزینه های استرداد طبق قوانین ایرلاین محاسبه میشود',
  'booking.valididentify':
    '3- لطفاً مدارك هویتی معتبر مانند کارت ملی ، شناسنامه یا گذرنامه را به همراه داشته باشید.',
  'booking.online': 'پرداخت از درگاه بانک',
  'booking.selectcountry': ' انتخاب کشور',
  'booking.changecountryholiday': 'تغییر مناسبت کشورها',
  'booking.calendar': 'تقویم',
  'booking.countercommissionreport': 'گزارش سهم کانتر',
  'booking.hasusername': ' حساب کاربری دارید ؟',
  'booking.nousername': 'حساب کاربری ندارید ؟ ',
  'booking.signuporguest': '(ثبت نام یا کاربر مهمان)',
  'booking.guestuser': 'کاربر مهمان',
  'booking.notuserbefore': 'ایجاد حساب کاربری',
  'booking.reservationfail': 'امکان رزرو این پرواز وجود ندارد',
  'booking.reservationerror': '!خطای رزرو پرواز',
  'booking.passengererror': 'خطا در اطلاعات مسافران !',
  'booking.passengerInformationHint':
    'لطفا اطلاعات مسافران را بررسی فرمایید...',
  'booking.displayticket': 'نحوه نمایش بلیط ',
  'booking.selectcustomer': 'انتخاب مشتری',
  'booking.asacustomer': 'تعیین طرف',
  'booking.changeticketprice': 'تغییر نمایش قیمت بلیط',
  'booking.save': 'ذخیره',
  'booking.fromwallet': 'کیف پول',
  'booking.fromcredit': 'پرداخت اعتباری',
  'booking.frompoint': 'امتیاز',
  'booking.usederik': 'پرداخت قیمت بلیط با دریک شما',
  'booking.yourderik': 'دریک شما',

  'booking.equivalentprice': 'معادل قیمت : ',
  'booking.bookinginvoiceno': 'شماره سفارش بلیط',
  'booking.importpnr': 'استفاده از پی ان آر',
  'booking.pnrhint': 'سیستم خود را انتخاب نمایید',
  'booking.pnrsteps': 'برای استفاده از پی ان آر لطفا این مراحل را انجام دهید: ',
  'booking.enteryour': '1 -لطفا وارد پنل آمادئوس خود شوید. ',
  'booking.enter': 'شوید.',
  'booking.openreference': '2 -رزرو خود را در سیستم آمادئوس بگیرید. ',
  'booking.pnr3': '3 - اطلاعات پاسپورت مسافر را به طور کامل وارد نمایید. ',
  'booking.entercommand':
    '4 -کد دستوری رو به رو را وارد نمایید و سپس کلید اینتر را بزنید. ',
  'booking.savepnr': '5 -پی ان  آر خود را ذخیره کنید و کلید اینتر را بزنید. ',
  'booking.pnr6':
    '6 -در صفحه تریپسی در بخش شماره رفرنس ، پی ان آر خود را وارد نمایید. ',
  'booking.pnr7': '7 -در بخش نام خانوادگی مسافر ، آن را وارد نمایید. ',
  'booking.pnr8': '8 -دکمه نمایش رزرو را بزنید. ',
  'booking.pnr9': '9 -پس از چک کردن اطلاعات به صفحه پرداخت بروید. ',
  'booking.pnr10': '10 -بلیط شما صادر شد. ',

  'booking.laststep':
    'اکنون می توانید رفرنس خود را در کادر زیر وارد نمایید و مراحل صدور را انجام دهید.',
  'booking.leadlastname': 'نام خانوادگی مسافر',
  'booking.usepnr': 'واکشی اطلاعات پی ان آر',
  'booking.buyer': 'خریدار',
  'booking.pnrnotfound': 'موردی یافت نگردید',
  'booking.uploadpassporterror': 'اطلاعات گذرنامه قابل خواندن نمی باشد',
  'booking.servererror': 'سرور دچار مشکل شده است',
  'booking.accessdenied': 'دسترسی عملیات غیر مجاز می باشد',
  'booking.newpassenger': 'ورود اطلاعات مسافر جدید',
  'booking.errormorepassenger':
    ' همه مسافران انتخاب شده است در صورت اطمینان روی دکمه مرحله بعد کلیک کنید',
  'booking.passengertypeerror': 'نوع مسافر غیر مجاز است',
  'booking.chooseallpassenger': 'لطفا تمام مسافران را انتخاب نمایید',
  'booking.checkpassport': 'لطفا پس از آپلود گذرنامه ، اطلاعات را چک بفرمایید.',
  'booking.apply': 'اعمال فیلتر',
  'booking.flightinformation': 'اطلاعات پرواز',
  'booking.adultticketprice': 'بلیط بزرگسال',
  'booking.childticketprice': 'بلیط خردسال',
  'booking.infantticketprice': 'بلیط نوزاد',
  'booking.airplane': 'هواپیما',
  'booking.time': 'ساعت پرواز',
  'booking.invoiceno': 'شماره سفارش',
  'booking.invoice': 'سفارش',
  'booking.charter': 'چارتر',
  'booking.systemic': 'سیستمی',
  'booking.type': 'نوع',
  'booking.paymentprice': 'قیمت نهایی',
  'booking.pnrcode': 'PNR',
  'booking.selectpayment': 'لطفا نوع پرداخت را انتخاب نمایید',
  'booking.temporaryreservation': 'رزرو موقت',
  'booking.direction': 'مسیر',
  'booking.passengercount': 'تعداد مسافر',
  'booking.reservesuccess': 'رزرو موقت با موفقیت انجام گردید',
  'booking.passengertotalprice': 'قیمت کل مسافرین',
  'booking.stopduration': 'مدت زمان توقف',
  'booking.invalidbirthdate': 'روز  تولد معتبر نیست',
  'booking.invalidexpireday': 'روز  تاریخ انقضای گذرنامه معتبر نیست',
  'booking.fullbirthdate': 'تاریخ تولد را بصورت کامل وارد نمایید',
  'booking.fullexpiredate': 'تاریخ انقضای گذرنامه را بصورت کامل وارد نمایید',
  'booking.creditpayment': 'پرداخت اعتباری با موفقیت انجام گرفت',
  'booking.walletpatment': 'پرداخت از کیف پول شما با موفقیت انجام گرفت',
  'booking.pointpayment': 'پرداخت از امتیاز شما با موفقیت انجام گرفت',
  'booking.tickettimelimit': 'مهلت رزرو',
  'booking.onbehalf': 'طرف حساب',
  'booking.expirereserve': 'منقضی',
  'booking.person': 'نفر',
  'booking.startorderdate': 'تاریخ سفارش از',
  'booking.endorderdate': 'تاریخ سفارش تا',
  'booking.missflight': 'جا مانده از پرواز',
  'booking.multiairline': 'چند ایرلاین',
  'booking.in': 'در',
  'booking.afterdiscount': 'قیمت پس از تخفیف',
  'booking.editissuer': 'اطلاعات گیرنده بلیط',
  'booking.referencenumber': 'رفرنس',
  'booking.train': 'قطار',
  'booking.bus': 'اتوبوس',
  'booking.economy': 'اکونومی',
  'booking.business': 'بیزینس',
  'booking.first': 'فرست',
  'booking.allcabinclasses':
    'در مسیر انتخابی شما کلیه کلاس های پروازی نمایش داده میشوند.',
  'booking.findtrip': 'سفرتو پیدا کن',
  'booking.selectacity': 'انتخاب شهر',
  'booking.destinations': 'مقصد ها',
  'booking.london': 'لندن',
  'booking.rome': 'رم',
  'booking.istanbul': 'استانبول',
  'booking.deletePassengerTitle': 'حذف مسافر',
  'booking.invalidnationalcode': 'کد ملی نا معتبر است',
  'booking.showgatewayerror': 'نمایش خطا',
  'booking.alternativefrom': 'از',
  'booking.alternativeto': 'به',
  'booking.commingsoon': 'به زودی',
  'booking.searchorigin': 'جستجوی مبدا',
  'booking.searchdestination': 'جستجوی مقصد',
  'booking.plannedflight': ' پرواز انتخابی شما',
  'booking.yesterday': 'دیروز',
  'booking.twodaysago': 'دو روز پیش',
  'booking.englishname': 'نام (انگلیسی)',
  'booking.englishlastname': 'نام خانوادگی (انگلیسی)',
  'booking.rialtotalprice': 'قیمت کل (ریال)',
  'booking.gotosearchflight': 'برو به جستجوی پرواز',
  'booking.seat': 'صندلی',
  'booking.englishticket': 'نسخه انگلیسی بلیط',
  'booking.persianticket': 'نسخه فارسی بلیط',
  'booking.searchmypassenger': 'جستجو در لیست مسافران قبلی',
  'booking.gotosearchflight': 'برو به جستجوی پرواز',
  'booking.seat': 'صندلی',
  'booking.selectairporterror':
    'لطفا فرودگاه مبدا و مقصد را از بالای صفحه انتخاب نمایید',
  'booking.providergateway': 'لیست کارگزار',
  'booking.noresultwithfilter':
    'با فیلترهای انتخابی شما پروازی یافت نگردید لطفا فیلترها را اصلاح نمایید',
  'booking.expirereservation': 'منقضی شده',
  'booking.unpaidreservation': 'تسویه نشده',
  'booking.selectbooking': 'لطفا بلیط های مورد نظر را جهت تسویه انتخاب نمایید',
  'booking.mobileformaterror': 'فرمت موبایل صحیح نمی باشد',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': 'هم اکنون هتل خود را با 30 درصد تخفیف رزرو کنید',
  'booking.tourdescription':
    'تور 21 روزه اروپا ویژه نوروز 1401. ثبت نام تا آخر آذر 5 درصد تخفیف',
  'booking.parishotel': 'هتل پاریس',
  'booking.tickettitle': 'بلیط :',
  'booking.stopdurationin': 'مدت توقف در ',
  'booking.contactInfo': 'اطلاعات گیرنده بلیط',
  'booking.expiredate': 'تاریخ انقضا',
  'booking.pnrdesc': 'در آمادئوس خود رزرو بگیرید و اینجا صادر کنید.',
  'booking.officeid': 'آفیس آیدی',
  'booking.pnrhelp': 'راهنمای استفاده',
  'booking.ticketinfo': 'مشخصات بلیط ارسالی',
  'booking.traveldatetime': 'تاریخ و زمان سفر',
  'booking.sale': 'فروش',
  'booking.buy': 'خرید',
  'booking.emailticket': 'ایمیل بلیط',
  'booking.changeticketprice': 'تغییر قیمت',
  'booking.backpreviouspage': 'بازگشت به صفحه قبل',
  'booking.changecabinclass': 'تغییر کلاس پرواز',
  'booking.changecabinclassnotify':
    'در صورت تغییر کلاس پرواز جستجوی مجدد انجام خواهد شد',
  'booking.ticketprice': 'قیمت بلیط',
  'booking.payableamount': 'مبلغ قابل پرداخت',
  'booking.showflight': 'نمایش پرواز',
  'booking.tripdirection': 'مسیر سفر',
  'booking.selectpaymenttype': 'مبلغ و نحوه پرداخت',
  'booking.title': 'عنوان',
  'booking.mr': 'آقا',
  'booking.mrs': 'خانم',
  'booking.yourchoice': 'انتخاب شما',
  'booking.result': 'نتیجه',
  'booking.changeflight': 'تغییر مسیر پرواز',
  'booking.flightOrigin': 'پرواز از مبدا',
  'booking.flightDestination': 'پرواز به مقصد',
  'booking.originCity': 'شهر مبدا را انتخاب کنید',
  'booking.destinationCity': 'شهر مقصد را انتخاب کنید',
  'booking.welcometripsi': 'به تریپسی خوش آمدید',
  'booking.welcometripord': 'به تریپ اُرد خوش آمدید',
  'booking.reservation': 'امکان رزرو موقت برای این پرواز وجود دارد',
  'booking.arrivetime': 'زمان رسیدن',
  'booking.sortbyarrivetime': 'براساس زمان رسیدن',
  'booking.sortbyduration': 'براساس مدت پرواز',
  'booking.sortbypoint': 'براساس امتیاز کاربر',
  'booking.tickettype': 'نوع بلیط',
  'bookking.tehran': 'تهران',
  'booking.mashhad': 'مشهد',
  'booking.mastercard': 'مسترکارت',
  'booking.debitCard': 'دبیت کارت',
  'booking.selectall': 'انتخاب همه',
  'booking.addpassenger': 'افزودن مسافر',
  'booking.textpassenger':
    'از طریق فرم زیر می توانید اطلاعات مسافر خود را وارد نمایید و در آخر ثبت اطلاعات کنید . ',
  'booking.loading': 'درحال بارگذاری...',
  'booking.showavailableflight': 'نمایش پروازهای موجود',
  'booking.roomtype': 'نوع اتاق',
  'booking.extrabed': 'تخت اضافه',
  'booking.numberofrooms': 'تعداد اتاق',

  'booking.addnewroom': 'افزودن اتاق جدید',
  'booking.picturesofroom': 'تصاویر اتاق',
  'booking.availsflight': 'پرواز موجود',
  'booking.events': 'رویدادهای تقویمی',
  'booking.eventsinfo': 'مشاهده رویدادها براساس کشور',
  'booking.want': 'می خوامش',
  'booking.setmaxprice': 'تعیین حداکثر قیمت بلیط',
  'booking.selectcity': 'لطفا ابتدا مبدا و مقصد را انتخاب نمایید',
  'booking.allcabinselected':
    'در پروازهای داخلی تمامی کلاسهای پروازی جستجو خواهد شد',
  'booking.all': 'کل',
  'booking.passportImage': 'تصویر گذرنامه',
  'booking.passporthint':
    'لطفا تصویر را بصورت واضح و  مطابق نمونه در سایز 500*700 آپلود نمایید',
  'booking.showsample': 'مشاهده نمونه پاسپورت',
  'booking.reservebefore': 'این پرواز قبلا توسط شما رزرو شده است',
  'booking.editpassengersinfo': 'ویرایش اطلاعات مسافران',
};
